// extracted by mini-css-extract-plugin
export default {"WhiteLabelNavbar":"LnG0KlV_","LogoImage":"LOd2nIiU","WhiteLabelNavbarText":"pXbvQ8nS"};